export class ExtendedControlsPrefix {
  private readonly BORDER_RADIUS = 'border-radius';
  private readonly PROPERTY_BORDER = 'border';

  private readonly updatedProperty: string;
  private readonly top: string;
  private readonly right: string;
  private readonly bottom: string;
  private readonly left: string;

  constructor(property: string, top: string, right: string, bottom: string, left: string) {
    this.updatedProperty = this.getUpdatedPropertyForExtendedControls(property);
    this.top = top;
    this.right = right;
    this.bottom = bottom;
    this.left = left;
  }

  getUpdatedProperty(): string {
    return this.updatedProperty;
  }

  getTop(): string {
    return this.top;
  }

  getRight(): string {
    return this.right;
  }

  getBottom(): string {
    return this.bottom;
  }

  getLeft(): string {
    return this.left;
  }

  getPrefixedTopProperty(): string {
    return this.updatedProperty + this.top;
  }

  getPrefixedBottomProperty(): string {
    return this.updatedProperty + this.bottom;
  }

  getPrefixedRightProperty(): string {
    return this.updatedProperty + this.right;
  }

  getPrefixedLeftProperty(): string {
    return this.updatedProperty + this.left;
  }

  private getUpdatedPropertyForExtendedControls(property: string): string {
    if (property === this.BORDER_RADIUS) {
      return this.PROPERTY_BORDER;
    }

    return property;
  }
}
